import baseStyles from '../sass/base.scss';
let commons = require('./utils/commons');
import mobileMenuJS from './includes/mobile_menu.js';
import mobileMenuLevelTwoDropdownJS from './includes/mobile_menu_level_two_dropdown.js';
import logoImg from '../img/logo.png';
import addressIconImg from '../img/address-icon.png';
import phoneIconMobileImg from '../img/phone-icon-mobile.png';
import mobileCloseCrestImg from '../img/mobile-close-crest.png';
import mobileSubMemuIconImg from '../img/mobile-sub-memu-icon.png';
